import { render, staticRenderFns } from "./category-tab.vue?vue&type=template&id=6e0dc7db&scoped=true"
import script from "./category-tab.vue?vue&type=script&lang=js"
export * from "./category-tab.vue?vue&type=script&lang=js"
import style0 from "./category-tab.vue?vue&type=style&index=0&id=6e0dc7db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0dc7db",
  null
  
)

export default component.exports